import React, { useEffect, useState } from 'react';
    import { HashRouter as Router, Routes, Route } from 'react-router-dom';
    import { AuthProvider } from './contexts/AuthContext';
    import { AppProvider } from './contexts/AppContext';
    import { AdminProvider } from './contexts/AdminContext';
    import Layout from './components/Layout';
    import Home from './pages/Home';
    import Community from './pages/Community';
    import StudyGroups from './pages/StudyGroups';
    import ChatRoom from './pages/ChatRoom';
    import StudyRoom from './pages/StudyRoom';
    import QuizPage from './pages/QuizPage';
    import Profile from './pages/Profile';
    import Settings from './pages/Settings';
    import Login from './pages/Login';
    import Register from './pages/Register';
    import Mission from './pages/Mission';
    import Vision from './pages/Vision';
    import AboutUs from './pages/AboutUs';
    import AboutMobile from './pages/AboutMobile';
    import OrganizationOverview from './pages/OrganizationOverview';
    import UserDirectory from './pages/UserDirectory';
    import Marketplace from './pages/Marketplace';
    import Feedback from './pages/Feedback';
    import AdminPanel from './pages/AdminPanel';
    import QuotesBrowser from './pages/QuotesBrowser';
    import QuoteAdmin from './pages/QuoteAdmin';
    import Quotes from './pages/Quotes';
    import AppSplash from './components/AppSplash';
    import './App.css';

    function App() {
      const [loading, setLoading] = useState(true);

      // Handle mobile viewport height for iOS
      useEffect(() => {
        const setAppHeight = () => {
          const vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
          document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
        };
        // Set initial height
        setAppHeight();
        // Update on resize and orientation change
        window.addEventListener('resize', setAppHeight);
        window.addEventListener('orientationchange', () => {
          setTimeout(setAppHeight, 100);
        });
        return () => {
          window.removeEventListener('resize', setAppHeight);
          window.removeEventListener('orientationchange', setAppHeight);
        };
      }, []);

      // Simulate app loading - reduced time for better mobile experience
      useEffect(() => {
        const timer = setTimeout(() => {
          setLoading(false);
        }, 1500); // Reduced from 2000ms to 1500ms
        return () => clearTimeout(timer);
      }, []);

      // Set up status bar for iOS
      useEffect(() => {
        if (navigator.standalone) {
          document.body.classList.add('standalone-mode');
        }
      }, []);

      return (
        <>
          {loading ? (
            <AppSplash />
          ) : (
            <Router>
              <AuthProvider>
                <AppProvider>
                  <AdminProvider>
                    <div className="mobile-app-container bg-neutral-50 dark:bg-neutral-900 text-neutral-800 dark:text-neutral-200">
                      {/* Status bar overlay for iOS */}
                      <div className="status-bar-overlay"></div>
                      <Routes>
                        {/* Login and Register routes - accessible without authentication */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />

                        {/* Community route - full page */}
                        <Route path="/community" element={<Community />} />

                        {/* Main app routes - all use Layout component */}
                        <Route path="/" element={<Layout />}>
                          <Route index element={<Home />} />
                          <Route path="study-groups" element={<StudyGroups />} />
                          <Route path="chat" element={<ChatRoom />} />
                          <Route path="study-room" element={<StudyRoom />} />
                          <Route path="quiz/:subject" element={<QuizPage />} />
                          <Route path="profile" element={<Profile />} />
                          <Route path="settings" element={<Settings />} />
                          <Route path="mission" element={<Mission />} />
                          <Route path="vision" element={<Vision />} />
                          <Route path="about" element={<AboutUs />} />
                          <Route path="about-mobile" element={<AboutMobile />} />
                          <Route path="organization" element={<OrganizationOverview />} />
                          <Route path="users" element={<UserDirectory />} />
                          <Route path="marketplace" element={<Marketplace />} />
                          <Route path="feedback" element={<Feedback />} />
                          <Route path="admin" element={<AdminPanel />} />
                          {/* Direct Quotes Browser Route */}
                          <Route path="quotes-browser" element={<QuotesBrowser />} />
                          {/* Quotes Management Routes */}
                          <Route path="quotes" element={<Quotes />} />
                          <Route path="quotes/:categoryId" element={<Quotes />} />
                          <Route path="quotes/:categoryId/:topicId" element={<Quotes />} />
                          <Route path="quotes/admin/:action" element={<QuoteAdmin />} />
                          <Route path="quotes/admin/:action/:id" element={<QuoteAdmin />} />
                        </Route>
                      </Routes>
                    </div>
                  </AdminProvider>
                </AppProvider>
              </AuthProvider>
            </Router>
          )}
        </>
      );
    }

    export default App;